/**
 * @generated SignedSource<<b532eb22f7839c6b4d47cab9f2425ec9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type goalTypeName$data = {
  readonly name: {
    readonly defaultValue?: string | null;
    readonly messageId?: string | null;
    readonly value?: string | null;
  } | null;
  readonly " $fragmentType": "goalTypeName";
};
export type goalTypeName$key = {
  readonly " $data"?: goalTypeName$data;
  readonly " $fragmentSpreads": FragmentRefs<"goalTypeName">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goalTypeName",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ],
          "type": "GoalTypeCustomName"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "messageId"
            },
            {
              "kind": "ScalarField",
              "name": "defaultValue"
            }
          ],
          "type": "LocalizationField"
        }
      ]
    }
  ],
  "type": "GoalType"
};

(node as any).hash = "880ea531cc4cd135f7665d0125b8cd50";

export default node;
